module.exports = __webpack_public_path__ + "d1745a2c3e47c7c5a1cbdc00f140d82c.svg";